import React from 'react';
import './chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter2() {
  const hyperlinkData = {
    origin: 'redbox',
    href: 'https://www.sharemyjanssenstory.com/?utm_source=CNN&utm_medium=Article&utm_campaign=SPR_SponCon&utm_id=Patient_Article',
    a: 'SHARE Network'
  };
  return (
    <div className="chapters__chapter">
      <div className="chapters__chapter__infobox chapters__chapter__infobox--red">
        <p>
          Allison, Ben, and Grace are volunteers with the{' '}
          <Hyperlink hyperlinkData={hyperlinkData} />, a Johnson & Johnson program made up of people
          who are dedicated to inspiring others through their personal health journeys and stories
          of caring.
        </p>
      </div>
      <p className="chapters__chapter__paragraph">
        As Ben puts it, “I always say there are one billion different ways to fall into clinical
        depression. But when you’re in it, it can feel the same for many people. And when I started
        to learn that the physical feelings and what was going on in my head weren’t unique, it was
        like, ‘Whoa! That person feels it, and that person feels it, and that person feels it. Well,
        let’s talk about it.’”
      </p>
    </div>
  );
}

export default Chapter2;
